import { Row, Col, Button, Tooltip } from 'antd';
import FooterControls from './FooterControls';
import { VIEWS } from '../../../utils/yourAccountUtils';

class DataEntry extends React.Component {
    constructor(props) { super(props); }

    formatInput(f, v) {
        switch(f) {
            case 'Role': return v === 'PROVIDER_ADMIN' ? 'Provider Admin' : v;
            default: return v;
        }
    }

    render() {
        const { field, value, style } = this.props;
        return (
            <Row type='flex' justify='space-around' align='middle' gutter={8} style={style}>
                <Col span={6}>
                    <span style={{ fontWeight: 'bold' }}>
                        {`${field}:`}
                    </span>
                </Col>
                <Col span={18} style={{ textAlign: 'left' }}>
                    {this.formatInput(field, value)}
                </Col>
            </Row>
        );
    }
}

export default class AccountInfo extends React.Component {
    constructor(props) { super(props); }

    highlighter(entries) {
        let
        keyPrefix = 'yout-account-account-info-data-entry-',
        commonStyle = {
            lineHeight: '30px',
            borderRadius: '4px',
            overflow: 'auto'
        },
        props = (i) => ({
            key: `${keyPrefix}${i}`,
            style: commonStyle
        });
        return entries.map((e, i) => i%2 === 0
            ? React.cloneElement(e, {...props(i), style: {...commonStyle, background: 'rgb(240, 240, 240)' } })
            : React.cloneElement(e, {...props(i)})
        );
    }

    render() {
        const
        p = this.props,
        { loading, services } = p;
        return (
            <div>
                <div style={{ position: 'absolute', top: '68px', right: '10px' }}>
                    <Tooltip placement='left' title='Edit contact info.'>
                        <Button
                            size='small'
                            icon='edit'
                            style={{ width: '74px', borderRadius: '20px' }}
                            onClick={() => services.changeView(VIEWS.EDIT_CONTACT_INFO)}
                        >
                            {'Edit'}
                        </Button>
                    </Tooltip>
                </div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={12}>
                        {this.highlighter([
                            <DataEntry key='account-info-data-entry-1' field='Name' value={
                                `${p.firstName != null && p.firstName.length > 0 ? p.firstName : ''}` +
                                `${p.lastName != null && p.lastName.length > 0 ? ` ${p.lastName}` : '-'}`
                            } />,
                            <DataEntry key='account-info-data-entry-2' field='Role' value={p.role} />,
                            <DataEntry key='account-info-data-entry-3' field='Phone' value={p.phoneNumber} />,
                            <DataEntry key='account-info-data-entry-4' field='Email' value={p.emailAddress} />
                        ])}
                    </Col>
                </Row>
                <FooterControls {...p} />
            </div>
        );
    }
}
